import moment from "jalali-moment";
import { v4 as uuidv4 } from "uuid";

export const addTime = min => {
  return moment().add(min, "m").format();
};
export const compaireTwoTime = time => {
  return moment().isBefore(time);
};
export const randomBetweenToNumber = (min, max) => {
  return uuidv4();
};
export const fancyTimeFormat = duration => {
  var hrs = ~~(duration / 3600);
  var mins = ~~((duration % 3600) / 60);
  var secs = ~~duration % 60;
  var ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
};

export const ToDateJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM/DD");
  } else {
    return null;
  }
};
export const ToDateMonthJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM");
  } else {
    return null;
  }
};
export const ToMonthJalali = date => {
  if (date) {
    return moment(date).locale("fa").format("YYYY/MM");
  } else {
    return null;
  }
};
export const ConvertDate = date => {
  if (date) {
    return moment.from(date, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
  } else {
    return null;
  }
};

export const ToTimeJalali = date => {
  if (date) {
    return moment(date).locale("fa").format(" HH:mm:ss - YYYY/MM/DD");
  } else {
    return null;
  }
};

export const ToTime = date => {
  if (date) {
    return moment(date).locale("fa").format("HH:mm:ss");
  } else {
    return null;
  }
};

export const getPosition = (string, index) => {
  return `${string.substring(0, index)}...`;
  // return string.split(subString).slice(index).join(subString);
};

export const GenderRender = value => {
  let gender;
  switch (value) {
    case "men":
    case "man":
      gender = "آقایان";
      break;
    case "women":
    case "woman":
      gender = "بانوان";
      break;
    case "both":
      gender = "آقایان و بانوان ";
      break;
    default:
      break;
  }
  return gender;
};

export const Day = day => {
  switch (day) {
    case "Fri":
    case "Friday":
      return "جمعه";
    case "Thu":
    case "Thursday":
      return "پنجشنبه";
    case "Wed":
    case "Wednesday":
      return "چهار شنبه";
    case "Tue":
    case "Tuesday":
      return "سه شنبه";
    case "Mon":
    case "Monday":
      return "دوشنبه";
    case "Sun":
    case "Sunday":
      return "یکشنبه";
    case "Sat":
    case "Saturday":
      return "شنبه";
    default:
      return "روز نا مشخص";
  }
};
export const CostRender = new Intl.NumberFormat("en-US");
export const RenderPrice = (data, count = 1) => {
  const { price } = data;
  if (data.second_price) {
    return `${CostRender.format(+data.second_price * count)} ${window.screen.width > 760 ? "تومان" : ""
      } `;
  }
  return `${CostRender.format(+price * count)} ${window.screen.width > 760 ? "تومان" : ""
    } `;
};

export const RenderChildPrice = (data, count = 1) => {
  const { childprice } = data;
  if (data.second_child_price) {
    return `${CostRender.format(+data.second_child_price * count)} ${window.screen.width > 760 ? "تومان" : ""
      } `;
  }
  return `${CostRender.format(+childprice * count)} ${window.screen.width > 760 ? "تومان" : ""
    } `;
};

export const sepMoney = (price, negNum) => {
  if (!price || price == "") {
    return price
  }
  if (negNum) {
    if (price < 0)
      return 0;
  }
  return CostRender.format(price);
};

export const removeSepMoney = (price) => {
  if (!price || price == "") {
    return price
  }
  let newPrice = price.split(',');
  newPrice = newPrice.join("");
  return newPrice
};

export const renderHeaderPrice = data => {
  const { header_price } = data;

  return `${CostRender.format(header_price)} ${window.screen.width > 760 ? "تومان" : ""
    } `;
};
export const renderCost = data => {
  const { header_price } = data;

  return `${CostRender.format(header_price)} ${window.screen.width > 760 ? "تومان" : ""
    } `;
};
export const addDate = days => {
  var result = new Date();
  result.setDate(result.getDate() + days);
  var month = result.getUTCMonth() + 1; //months from 1-12
  var day = result.getUTCDate();
  var year = result.getUTCFullYear();
  return year + "/" + month + "/" + day;
};

export const dateYMD = () => {
  var result = new Date();
  var month = result.getUTCMonth() + 1; //months from 1-12
  var day = result.getUTCDate();
  var year = result.getUTCFullYear();
  return year + "/" + month + "/" + day;
};
export const dateInputYMD = date => {
  var result = new Date(date);
  var month = result.getUTCMonth() + 1; //months from 1-12
  var day = result.getUTCDate();
  var year = result.getUTCFullYear();
  return year + "/" + month + "/" + day;
};
export const compaireTwoDate = (date, now, time) => {
  if (new Date(date).getTime() == new Date(now).getTime()) {
    if (compareTwoHour(time)) {
      return true;
    } else {
      return "today";
    }
  }

  return new Date(date) < new Date(now);
};
const compareTwoHour = time => {
  let now = new Date();
  if (
    time &&
    renderData(time.split("-")[0].toString()) <
    now.getHours() * 60 + now.getMinutes()
  ) {
    return true;
  }
};
const renderData = data => {
  if (data.includes(":")) {
    if (+data.split(":")[0] * 60 + +data.split(":")[1] == 0) {
      return 24 * 60;
    }
    if (+data.split(":")[0] * 60 + +data.split(":")[1] < 240) {
      return 24 * 60;
    }

    return +data.split(":")[0] * 60 + +data.split(":")[1];
  } else {
    return +data * 60;
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
export const renderMonth = data => {
  switch (data) {
    case "01":
    case 1:
      return "فروردین";
    case "02":
    case 2:
      return "اردیبهشت";
    case "03":
    case 3:
      return "خرداد";
    case "04":
    case 4:
      return "تیر";
    case "05":
    case 5:
      return "مرداد";
    case "06":
    case 6:
      return "شهریور";
    case "07":
    case 7:
      return "مهر";
    case "08":
    case 8:
      return "آبان";
    case "09":
    case 9:
      return "آذر";
    case "10":
    case 10:
      return "دی";
    case "11":
    case 11:
      return "بهمن";
    case "12":
    case 12:
      return "اسفند";
    default:
      return "نامشخص";
  }
};

export const cutText = (txt, length = 20) => {
  if (txt.length < length) {
    return txt;
  }
  if (txt) {
    return `${txt.slice(0, length)} ...`;
  }
};
export const renderTimeMonth = date => {
  if (date) {
    let jalali = ToDateJalali(date).split("/");
    return `${renderDay(jalali[2])} ${renderMonth(jalali[1])}`;
  }
};
const renderDay = day => {
  if (day) {
    if (day.split("")[0] == "0") {
      return day.split("")[1];
    } else {
      return day;
    }
  }
};

export const renderTimeShift = time => {
  if (time) {
    return time;
  }
  return "8";
};

export const takePercent = ({ price, second_price }) => {
  if (price && second_price) {
    return Math.ceil((1 - second_price / price) * 100);
  } else {
    return 10;
  }
};
export const renderImage = item => {
  if (item.header_image) {
    return item.header_image;
  } else {
    if (item.images == null)
      return;
    return item.images[0];
  }
};
export const renderAltImage = item => {
  if (item.imgaes_alt) {
    if (Array.isArray(item.imgaes_alt) && item.imgaes_alt.length > 0) {
      return item.images_alt[0];
    } else {
      return item.name;
    }
  } else {
    return item.name;
  }
};
export const differenceToTimeSecounds = (firstTime, secondTime = moment()) => {
  return secondTime.diff(moment(firstTime));
};
export const checkToday = timestamp => {
  if (
    moment(timestamp).format("DD/MM/YYYY") ==
    moment(new Date()).format("DD/MM/YYYY")
  )
    return true;
  else {
    return false;
  }
};
export const renderCategoryName = id => {
  switch (+id) {
    case 1:
      return "استخر و مجموعه های آبی";
    case 2:
      return "سالن ورزشی";

    case 3:
      return "باشگاه بدنسازی";
    default:
      break;
  }
};
export const renderCategoryRoute = id => {
  switch (id) {
    case 1:
    case "1":
      return { route: "/pool", name: "استخر و مجموعه های ورزشی" };
    case 2:
    case "2":
      return { route: "/salon", name: "سالن ورزشی" };
    case 3:
    case "3":
      return { route: "/gym", name: "باشگاه بدنسازی" };
    case "pool":
      return { route: "/pool", id: 1, name: "استخر و مجموعه های ورزشی" };
    case "salon":
      return { route: "/salon", id: 2, name: "سالن ورزشی" };
    case "gym":
      return { route: "/gym", id: 3, name: "باشگاه بدنسازی" };
    default:
      return { route: "/pool" };
      break;
  }
};
export const renderItemSinglePath = (category_id, city_slug, slug) => {
  return `${renderCategoryRoute(category_id)["route"]}/${city_slug}/${slug}`;
};
